import React from 'react';
import { ButtonApp } from 'src/components/ApartmentPageV2/Button';
import { ReactComponent as LinkDealIcon } from 'src/assets/icon_apartment_link_deal.svg';
import { useStyles } from 'src/components/ApartmentConnectDeal/components/Buttons/DealButton/styles';

interface DealButtonProps {
  text?: string;
  onClick?: () => void;
}
export const DealButton: React.FC<DealButtonProps> = ({ text, onClick }) => {
  const styles = useStyles();
  return (
    <>
      <ButtonApp
        startIcon={<LinkDealIcon />}
        customClassName={styles.button}
        fullWidth
        text={text}
        variant="contained"
        onClick={onClick}
      />
    </>
  );
};
